const keyResult = (keyResult = null, action) => {
    switch (action.type) {
        case "SET_KEY_RESULT":
            return action.keyResult;
        default:
            return keyResult;
    }
};
export default keyResult;